import firebase from 'firebase';

require('firebase/database');

let config = {
    apiKey: "AIzaSyB35mP4dCD8-gHvIrbveIoMzTy54Zhnas0",
    authDomain: "sentai-e1452.firebaseio.com/",
    databaseURL: "https://sentai-e1452.firebaseio.com/",
    projectId: "sentai-e1452",
};

let fireBaseObject = firebase.initializeApp(config);

let db = fireBaseObject.database();


const functions = {

    getMovieList(){
        return db.ref('movieList').once('value').then((snapshot) => {
            return snapshot.val();
        });
    },

    getMovie(movie){
        return db.ref(movie).once('value').then((snapshot) => {
            return snapshot.val();
        });
    }
};

export default functions



// WEBPACK FOOTER //
// ./src/util/firebase.js